var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useId } from 'react';
import { ModalWindow, ModalHeader, ModalFooter, ModalContent, ModalSizes, } from './components';
export const Modal = (_a) => {
    var { children, footer, footerAlign, onClose, open, portal = true, scrollable = true, size, title, focusTrapOptions, contentClassName } = _a, rest = __rest(_a, ["children", "footer", "footerAlign", "onClose", "open", "portal", "scrollable", "size", "title", "focusTrapOptions", "contentClassName"]);
    const id = useId();
    const modalLabel = `modalLabel_id_${id}`;
    const modalDescribedby = `modalDescribedby_id_${id}`;
    return (React.createElement(ModalWindow, Object.assign({ onClose: onClose, size: size, focusTrapOptions: focusTrapOptions, open: open, portal: portal, role: "alertdialog", "data-anvil-component": "Modal", "aria-modal": "true", "aria-labelledby": modalLabel, "aria-describedby": modalDescribedby }, rest),
        React.createElement(ModalHeader, { id: modalLabel, title: title, onClose: onClose }),
        React.createElement(ModalContent, { className: classnames('fs-3', contentClassName), scrollable: scrollable, id: modalDescribedby }, children),
        footer && React.createElement(ModalFooter, { align: footerAlign }, footer)));
};
Modal.Window = ModalWindow;
Modal.Header = ModalHeader;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
Modal.Sizes = ModalSizes;
//# sourceMappingURL=Modal.js.map